<template>
	<div v-if="sighting.can_vet" class="vettingBar">
		<button @click="clickAccept" class="btn btn-success" :disabled="sighting.status == APIStatuses.accpeted">Accept</button>
		<!-- Accept moves to next record -->
		<button @click="clickPending" class="btn btn-warning" :disabled="sighting.status == APIStatuses.pending">Pending</button>
		<!-- Pending Stays on this record -->
		<button @click="clickDecline" class="btn btn-danger" :disabled="sighting.status == APIStatuses.declined">Decline</button>
		<!-- decline validates decision notes and then moves to next record -->

		<button @click="clickDelete" class="btn btn-white pull-right">Delete</button>
		<button @click="clickDeletePhotos" class="btn btn-primary pull-right" v-if="sighting.can_vet_edit && sighting.photos.length > 0">Delete Photo(s)</button>
		<!-- confirms and moves to next record -->
		&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-info-circle" data-tooltip="Assigning a status will also save modified taxon and decision notes."></i>
	</div>
</template>

<script>
export default {
	name: 'VettingBar',
	props: ['value'],
	data: function(){
		return {
			sighting: this.value ? this.value : null,
		};
	},
	mounted: function(){

	},
	methods:{
		getPatchDataToSave:function(status){
			var patchData = {
				vetter_notes: this.sighting.vetter_notes,
				status:status,
			}
			if (this.sighting.correctedTaxon) {
				patchData.taxon = this.sighting.correctedTaxon.id;
			}
			return patchData;
		},
		notifySaved:function(){
			this.$notify({
				text: 'Sighting Saved',
				type: 'success',
			});
		},
		notifyError:function(error){
			this.$notify({
			  text: 'There was an error saving your data: ' + error,
			  type: 'error',
			});
		},
		clickAccept:function(){
			var self = this;
			this.API({
				endpoint: 'sightings/' + self.sighting.id,
				isPatch:true,
				postData: self.getPatchDataToSave(self.APIStatuses.accpeted),
				funcThen: function(response){
					self.notifySaved();
					self.$emit('sightingVettingChanged', self.sighting.id, true);
				},
				funcCatch: function(error){
					self.notifyError(error.response.data);
				},
			});
		},
		clickPending:function(){
			var self = this;
			this.API({
				endpoint: 'sightings/' + self.sighting.id,
				isPatch:true,
				postData: self.getPatchDataToSave(self.APIStatuses.pending),
				funcThen: function(response){
					self.notifySaved();
					self.$emit('sightingVettingChanged', self.sighting.id, false);
				},
				funcCatch: function(error){
					self.notifyError(error.response.data);
				},
			});
		},
		clickDecline:function(){
			if (!this.sighting.vetter_notes || this.sighting.vetter_notes.trim() == '') {
				this.$notify({
				  text: 'Please enter decision notes.',
				  type: 'error',
				});
				return;
			}

			var self = this;
			this.API({
				endpoint: 'sightings/' + self.sighting.id,
				isPatch:true,
				postData: self.getPatchDataToSave(self.APIStatuses.declined),
				funcThen: function(response){
					self.notifySaved();
					self.$emit('sightingVettingChanged', self.sighting.id, true);
				},
				funcCatch: function(error){
					self.notifyError(error.response.data);
				},
			});
		},
		clickDelete:function(){
			if (!confirm("Are you sure you want to permanently delete this record?")) {
				return;
			}
			var self = this;
			this.API({
				endpoint: 'sightings/' + self.sighting.id,
				isDelete:true,
				funcThen: function(response){
					self.$notify({
					  text: 'Sighting Deleted',
					  type: 'success',
					});
					self.$emit('sightingDeleted', self.sighting.id);
				},
				funcCatch: function(error){
					self.notifyError(error.response.data);
				},
			});
		},
		clickDeletePhotos:function(){
			this.$emit('deletePhotos', this.sighting.id);
		},
	},
	watch: {
		'sighting': function(val){
			this.$emit('input', this.sighting);
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/components/VettingBar.vue